export function getLocation() {
  return window.location
}
